import { useState } from "react";
import { useMutation, UseMutationOptions } from "react-query";

import { uploadOrderCSV } from "../../api/fulfillment/order";

type UploadOrderCSVSuccess = { message?: string };
type UploadOrderCSVVariables = {
  organization_id: string;
  orderDetailsCSV: File;
  orderItemsCSV: File;
};
export type UploadOrderCSVError = {
  errors: { line: number; messages: string[] }[];
};
type MutationConfig = UseMutationOptions<UploadOrderCSVSuccess, UploadOrderCSVError, UploadOrderCSVVariables>;

export const useUploadOrderMutation = (config: MutationConfig) => {
  const [error, setError] = useState<UploadOrderCSVError>();
  const result = useMutation(
    ({ organization_id, orderDetailsCSV, orderItemsCSV }: UploadOrderCSVVariables) =>
      uploadOrderCSV(organization_id, orderDetailsCSV, orderItemsCSV, {
        transformResponse: (response) => {
          const res = JSON.parse(response);
          if (res?.type === "error") {
            let { errors } = res;
            if (!errors && res?.message) errors = [{ line: 0, messages: [res.message] }];
            setError({ errors });
          }
          return res;
        },
      }),
    { ...config, onMutate: () => setError(undefined), onError: undefined }
  );
  return { ...result, error };
};
